import { CallRetentionPolicyTypes, OrderingOption } from 'generated/graphql-types';

import { Component, EventEmitter, Input, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDatepicker } from '@angular/material/datepicker';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { extensionsRoute } from 'src/app/app-routing.module';
import { setHideRecordingDate } from 'src/app/common-components/helpers/call-logs-helper';
import { RegisterOptions } from 'src/app/common-components/register/models/register-options';
import { EntityRegisterView } from 'src/app/common-components/register/models/register-view';
import { getSelectedAccountId } from 'src/app/store/select-account/select-account.selector';
import { AccountDetailApiService } from '../../account-details/services/account-detail-api.service';
import { FileOption } from '../../prompt-details/models/file.option.interface';
import { CallParkingRegisterListItem } from '../../tiles/views/call-parking/models/parking-log-register-results.model';
import { CallParkingRegisterOptions } from '../models/call-parkinglot-register-options';
import { ExtensionsPrivileges } from '../models/extensions-privileges';
import { selectQuickFilters } from '../state/call-parkinglot-register.reducer';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-parkinglot-register-view',
    styleUrls: ['./call-parking-register-view.component.scss'],
    templateUrl: './call-parking-register-view.component.html',
    standalone: false
})
export class CallParkingRegisterViewComponent extends EntityRegisterView<
   CallParkingRegisterListItem,
   CallParkingRegisterOptions,
   OrderingOption
> {
   protected selectQuickFilters(): (state: object) => RegisterOptions | null {
      return selectQuickFilters;
   }
   @ViewChild('picker') picker: MatDatepicker<Date>;

   @Input() extensionsPrivileges: ExtensionsPrivileges;

   @Input() isSystemUser: boolean;

   @Output() listen = new EventEmitter<Array<FileOption>>();

   callRetentionPolicyTypeId: CallRetentionPolicyTypes | null;

   currentAccount$: Observable<number | null>;

   hideRecordingDate: string;

   constructor(public store: Store, private accountDetailApiService: AccountDetailApiService) {
      super(store);
      this.currentAccount$ = store.select(getSelectedAccountId);

      this.currentAccount$
         .pipe(
            take(1),
            filter((accountId: number | null): accountId is number => {
               return accountId != null;
            })
         )
         .subscribe((accountId: number) => {
            this.fetchAccountDetails(accountId);
         });
   }

   getRouterLink(id: number) {
      return `/${extensionsRoute}/${id}`;
   }

   fetchAccountDetails(accountId: number): void {
      this.accountDetailApiService.getAccountDetails(accountId).subscribe((result) => {
         if (result.data) {
            this.callRetentionPolicyTypeId = result.data.account.callRetentionPolicyTypeId;
            this.hideRecordingDate = setHideRecordingDate(this.callRetentionPolicyTypeId);
         }
      });
   }

   onFilterChange(filterValues: { startDate: Date; endDate: Date; fromDuration: number; toDuration: number }) {
      const { startDate, endDate, fromDuration, toDuration } = filterValues;
      this.registerOptions = { ...this.registerOptions };
      this.quickFilterChange.emit(this.registerOptions);
   }
}
